import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Edit from "../../../assets/images/editinput.svg";
import "../../../../src/styles/userManagement.css";
import useHttp from "../../../hooks/useHttp";
import APIService from "../../../services/apiAxiosService";
import displayToastMessage from "../../Common/Alert/displayToastMessage";

const EditUsersModal = (props) => {
    let { userData, setVisible, setUserData, fetchUserList, setSearch } = props;
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [emailID, setEmailID] = useState("");
    const [userPhone, setUserPhone] = useState("");
    const [errorFirstUserMessage, setErrorFirstUserMessage] = useState("");
    const [errorLastUserMessage, setErrorLastUserMessage] = useState("");
    const [errorPhoneNoMsg, setErrorPhoneNoMsg] = useState("");
    const [errorEmailMessage, setErrorEmailMessage] = useState("");
    const [isErrorMessageShown, setIsErrorMessageShown] = useState(false);
    const { sendRequest: editUsers } = useHttp();

    useEffect(() => {
        setFirstName(userData?.firstName);
        setLastName(userData?.lastName);
        setUserPhone(userData?.userPhone);
        setEmailID(userData?.emailID);
    }, [userData]);

    const validateInputFields = (value) => {
        let reg = /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/;
        return !!(value.match(reg));
      };

    const handleFirstName = (e) => {
        if (validateInputFields(e.target.value) || e.target.value === "") {
          setFirstName(e.target.value);
          setErrorFirstUserMessage("");
          setIsErrorMessageShown(false);
        } else {
            setIsErrorMessageShown(true);
            setErrorFirstUserMessage("Special characters are not allowed");
        }
      };
    
      const handleLastName = (e) => {
        if (validateInputFields(e.target.value) || e.target.value === "") {
          setLastName(e.target.value);
          setErrorLastUserMessage("");
          setIsErrorMessageShown(false);
        } else {
            setIsErrorMessageShown(true);
            setErrorLastUserMessage("Special characters are not allowed");
        }
      };
      const handlePhoneNumber = (e) => {
        if (validateInputFields(e.target.value) || e.target.value === "") {
          setUserPhone(e.target.value);
          setErrorPhoneNoMsg("");
          setIsErrorMessageShown(false);
        } else {
            setIsErrorMessageShown(true);
            setErrorPhoneNoMsg("Special characters are not allowed");
        }
      };

      const handleEmailValue = (e) => {
        if (e.target.value || e.target.value === "") {
          setEmailID(e.target.value);
          setErrorEmailMessage("");
          setIsErrorMessageShown(false);
        } else {
            setIsErrorMessageShown(true);
            setErrorEmailMessage("Special characters are not allowed");
        }
      };

      const handleSubmit = () => {
        let emailReg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        let phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
        if (firstName.trim() === "") {
        setErrorFirstUserMessage("First Name is required");
        setIsErrorMessageShown(true);
        return false;
        }
        if (lastName.trim() === "") {
        setErrorLastUserMessage("Last Name is required");
        setIsErrorMessageShown(true);
        return false;
        }
        if (emailReg.test(emailID) === false) {
        setErrorEmailMessage("Email id is required in the correct format");
        setIsErrorMessageShown(true);
        return false;
        }
        if (phoneRegExp.test(userPhone) === false) {
        setErrorPhoneNoMsg("Phone Number is required");
        setIsErrorMessageShown(true);
        return false;
        }
        let payload = {
            userID: userData?.userID,
            firstName: firstName.trim(),
            lastName: lastName.trim(),
            userPhone: userPhone.trim(),
            emailID: emailID.trim().toLowerCase(),
            validateEmailID: userData?.emailID.trim().toLowerCase(),
            email:sessionStorage.getItem("email"),
            };
          try {
            editUsers(APIService.editUsers(payload), responseHandler, errorHandler)
          }
          catch (error) {
            setFirstName("");
            setLastName("");
            setUserPhone("");
            setEmailID("");
            setErrorFirstUserMessage("");
            setErrorLastUserMessage("");
            setErrorPhoneNoMsg("");
            setErrorEmailMessage("");
            setIsErrorMessageShown(false);
            setUserData({});
            setVisible(false);
            displayToastMessage("Something went wrong, Please try again!", "error");
            setSearch("");
          }
      }

      const responseHandler = (data) => {
        if (data.CODE) {
          setVisible(false);
          setFirstName("");
          setLastName("");
          setUserPhone("");
          setEmailID("");
          setErrorFirstUserMessage("");
          setErrorLastUserMessage("");
          setErrorPhoneNoMsg("");
          setErrorEmailMessage("");
          setIsErrorMessageShown(false);
          setUserData({});
          displayToastMessage("User edited successfully", "success");
          setSearch("");
          fetchUserList();
        }
        else {
          let Msg = "Action failed. Please try again!";
          setVisible(false);
          setFirstName("");
          setLastName("");
          setUserPhone("");
          setEmailID("");
          setErrorFirstUserMessage("");
          setErrorLastUserMessage("");
          setErrorPhoneNoMsg("");
          setErrorEmailMessage("");
          setIsErrorMessageShown(false);
          setUserData({});
          setSearch("");
          displayToastMessage(Msg, "error");
        }
      }

      const errorHandler = () => {
        setVisible(false);
        setFirstName("");
        setLastName("");
        setUserPhone("");
        setEmailID("");
        setErrorFirstUserMessage("");
        setErrorLastUserMessage("");
        setErrorPhoneNoMsg("");
        setErrorEmailMessage("");
        setIsErrorMessageShown(false);
        setSearch("");
        setUserData({});
        displayToastMessage("User email is already registered, please enter new email", "error");
      }

      const handleCancel = () => {
        setVisible(false);
        setFirstName("");
        setLastName("");
        setUserPhone("");
        setEmailID("");
        setErrorFirstUserMessage("");
        setErrorLastUserMessage("");
        setErrorPhoneNoMsg("");
        setErrorEmailMessage("");
        setIsErrorMessageShown(false);
        setUserData({});
      }

    return (
        <div className="create-vendor-form-container">
          <div className="row">
            <div className="col-sm-6">
              <div className="cv-input-field-container pt-0 pb-0">
                <label htmlFor="FirstNameEditUser" className="cv-input-label">
                  First Name<span className="asterisk-required">*</span>
                </label>
                <input
                  className="cv-input-field pl-2"
                  type="text"
                  id="FirstNameEditUser"
                  value={firstName}
                  placeholder="Please enter first name"
                  onChange={handleFirstName}
                  name="name"
                />
                <img alt="edit" src={Edit} className="edit-input" />
              </div>
              <div className="cv-input-field">
                <span
                  className="form-label errorMsg"
                  style={{
                    display: isErrorMessageShown ? "block" : "none",
                  }}
                >
                  {errorFirstUserMessage}
                </span>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="cv-input-field-container pt-0 pb-0">
                <label htmlFor="LastNameEditUser" className="cv-input-label">
                  Last Name<span className="asterisk-required">*</span>
                </label>
                <input
                  className="cv-input-field"
                  type="text"
                  id="LastNameEditUser"
                  value={lastName}
                  placeholder="Please enter last name"
                  onChange={handleLastName}
                  name="name"
                />
                <img alt="edit" src={Edit} className="edit-input" />
              </div>
              <div className="cv-input-field">
                <span
                  className="form-label errorMsg"
                  style={{
                    display: isErrorMessageShown ? "block" : "none",
                  }}
                >
                  {errorLastUserMessage}
                </span>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 ">
              <div className="cv-input-field-container pt-0 pb-0">
                <label htmlFor="EmailEditUser" className="cv-input-label">
                  Email <span className="asterisk-required">*</span>
                </label>
                <input
                  className="cv-input-field pl-2"
                  type="email"
                  id="EmailEditUser"
                  value={emailID}
                  placeholder="Please enter email"
                  onChange={handleEmailValue}
                  name="Email"
                />
                <img alt="edit" src={Edit} className="edit-input" />
              </div>
              <div className="cv-input-field">
                <span
                  className="form-label errorMsg"
                  style={{
                    display: isErrorMessageShown ? "block" : "none",
                  }}
                >
                  {errorEmailMessage}
                </span>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="cv-input-field-container pt-0 pb-0">
                <label htmlFor="PhoneNumberEditUser" className="cv-input-label">
                  Phone Number<span className="asterisk-required">*</span>
                </label>
                <input
                  className="cv-input-field"
                  type="number"
                  id="PhoneNumberEditUser"
                  value={userPhone}
                  placeholder="Please enter phone number"
                  onChange={handlePhoneNumber}
                  name="PhoneNumber"
                />
                <img alt="edit" src={Edit} className="edit-input" />
              </div>
              <div className="cv-input-field">
                <span
                  className="form-label errorMsg"
                  style={{
                    display: isErrorMessageShown ? "block" : "none",
                  }}
                >
                  {errorPhoneNoMsg}
                </span>
              </div>
            </div>
          </div>
          <div className="options-container">
                <button
                        type="button"
                        className="cancel-button"
                        onClick={handleCancel}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="save-button m-l-2"
                        onClick={handleSubmit}
                    >
                        Submit
                </button>
            </div>
          </div>
    )
}

EditUsersModal.propTypes = {
    userData: PropTypes.any,
    setVisible: PropTypes.any,
    fetchUserList: PropTypes.any,
    setUserData: PropTypes.any,
    setSearch: PropTypes.any
}

export default EditUsersModal;